<form [formGroup]="planForm">
  <div class="dashboard-tile">
  <div class="tile-header">
    <div *ngIf="_plan?.id" class="tile-header-title">Update Plan <span class="text-primary">{{_plan.name}}</span></div>
    <div *ngIf="!_plan?.id" class="tile-header-title">New Plan</div>
  </div>
    <div class="tile-content">
      <div class="formFieldList" style="width:48%; display:inline-block; vertical-align:top; padding-right:20px;">
        <mat-form-field>
          <input matInput placeholder="Plan Name" formControlName="planName" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Trial Period Days" formControlName="planTrialPeriodDays" type="number" required>
        </mat-form-field>
      </div>
      <div class="formFieldList" style="width:48%; display:inline-block; vertical-align:top;">
        <mat-form-field>
          <input matInput placeholder="External Product" formControlName="planExternalProduct" type="string">
        </mat-form-field>
        <div><mat-checkbox formControlName="planIsPublic">Public</mat-checkbox></div>
      </div>
      <mat-form-field style="width:100%">
        <textarea matInput placeholder="Description" formControlName="planDescription" required style="min-height:75px;"></textarea>
      </mat-form-field>
    </div>
    <div class="tile-subheader">
      <div class="tile-subheader-title">Plan Features</div>
    </div>
    <div class="tile-content">

      <table mat-table [dataSource]="getAccountFeatureTypes()">
        <ng-container matColumnDef="feature">
          <th mat-header-cell *matHeaderCellDef style="width:400px; padding:10px;">Feature</th>
          <td mat-cell *matCellDef="let featureType" style="width:500px; padding:10px;">
              {{featureType.featureType}}<br>{{featureType.description}}
          </td>
        </ng-container>

        <ng-container matColumnDef="trial">
          <th mat-header-cell *matHeaderCellDef style="width:250px; padding: 10px" >Trial Value</th>
          <td mat-cell *matCellDef="let featureType" style="width:250px; padding:10px;">
            <mat-checkbox *ngIf="featureType.dataType == 'boolean'" [formControlName]="'TRIAL_' + featureType.featureType"></mat-checkbox>
            <mat-form-field *ngIf="featureType.dataType == 'number'" style="width:100%">
              <input matInput [formControlName]="'TRIAL_' + featureType.featureType" type="number">
            </mat-form-field>
            <mat-form-field *ngIf="featureType.featureType == 'ALLOWED_ASSESSMENT_ID'" style="width:100%">
              <input type="text" matInput placeholder="Assessments" [formControlName]="'TRIAL_' + featureType.featureType" [matAutocomplete]="assessments.auto">
              <cw-assessments-dropdown #assessments [searchControl]="planForm.controls.TRIAL_ALLOWED_ASSESSMENT_ID" 
                (stateChange)="onStateChange($event)" [MultiSelection]="'TRIAL_' + featureType.featureType">
              </cw-assessments-dropdown>
            </mat-form-field>
            <mat-form-field *ngIf="featureType.featureType == 'SUB_ACCOUNT_PLAN'" style="width:100%">
              <mat-select [formControlName]="'TRIAL_' + featureType.featureType" multiple>
                <mat-option *ngFor="let plan of plans" [value]="plan.id">{{plan.name}} (id: {{plan.id}})</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="subscription">
          <th mat-header-cell *matHeaderCellDef style="width:250px; padding:10px;">Subscription Value</th>
          <td mat-cell *matCellDef="let featureType" style="width:250px; padding:10px;">
            <mat-checkbox *ngIf="featureType.dataType == 'boolean'" [formControlName]="featureType.featureType"></mat-checkbox>
            <mat-form-field *ngIf="featureType.dataType == 'number'" style="width:100%">
              <input matInput [formControlName]="featureType.featureType" type="number">
            </mat-form-field>
            <mat-form-field *ngIf="featureType.featureType == 'ALLOWED_ASSESSMENT_ID'" style="width:100%">              
              <input type="text" matInput placeholder="Assessments" [formControlName]="featureType.featureType" [matAutocomplete]="assessments.auto">
              <cw-assessments-dropdown #assessments [searchControl]="planForm.controls.ALLOWED_ASSESSMENT_ID" 
                (stateChange)="onStateChange($event)" [MultiSelection]="'SUB_' + featureType.featureType">
              </cw-assessments-dropdown>
            </mat-form-field>
            <mat-form-field *ngIf="featureType.featureType == 'SUB_ACCOUNT_PLAN'" style="width:100%">
              <mat-select [formControlName]="featureType.featureType" multiple>
                <mat-option *ngFor="let plan of plans" [value]="plan.id">{{plan.name}} (id: {{plan.id}})</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
      </table>

      <div class="tile-footer centered">
        <button [disabled]="planForm.invalid" mat-raised-button type="submit" color="primary" (click)="savePlan()">Save</button>
        <button mat-raised-button type="button" color="primary" (click)="cancelPlan()">Cancel</button>
      </div>
    </div>
</div>
</form>
